import { styled } from '@mui/material/styles';
import InputLabel from '@mui/material/InputLabel';

const StyledLabel = styled(InputLabel)({ fontWeight: 500, fontSize: '0.875rem' });

export default StyledLabel;
